module.exports = __webpack_public_path__ + "img/1372483246.94d452a0.jpg";